import { render } from "./PackagesManagerItemsStage.vue?vue&type=template&id=2321a6b2&scoped=true"
import script from "./PackagesManagerItemsStage.vue?vue&type=script&lang=js"
export * from "./PackagesManagerItemsStage.vue?vue&type=script&lang=js"

import "./PackagesManagerItemsStage.vue?vue&type=style&index=0&id=2321a6b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2321a6b2"]])

export default __exports__